/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricsAggregateResultForAi {
    getFixupPrototypeFunction() { return UtilizationMetricsAggregateResultForAi.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricsAggregateResultForAi>): UtilizationMetricsAggregateResultForAi {
        let obj = Object.assign(new UtilizationMetricsAggregateResultForAi(), model);
        UtilizationMetricsAggregateResultForAi.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricsAggregateResultForAi>): UtilizationMetricsAggregateResultForAi {
        if (!model) return null;
        return UtilizationMetricsAggregateResultForAi.newInstance(<UtilizationMetricsAggregateResultForAi> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricsAggregateResultForAi) {
        if (!obj) return;

        models.UtilizationMetricsAggregateResultForAi.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricsAggregateResultForAi): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricsAggregateResultForAi.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.identity) {
            models.UtilizationMetricIdentityForAi.fixupPrototype(this.identity);
        }
        if (this.metric_series) {
            models.UtilizationMetricSeries.fixupPrototype(this.metric_series);
        }
        if (this.timestamps) {
            for (let i = 0; i < this.timestamps.length; i++) {
                let val = this.timestamps[i];
                if (typeof val === "string") {
                    this.timestamps[i] = new Date(<string><any>val);
                }
            }
        }
    }

    /**
     * AI caller identity of the result group.
     */
    identity: models.UtilizationMetricIdentityForAi;

    /**
     * Statistical summary of utilization metric data.
     */
    metric_series: models.UtilizationMetricSeries;

    /**
     * timestamps
     */
    timestamps: Array<Date>;

}
